export default __webpack_public_path__ + "static/media/mojisola.28650871.jpg";